import { Injectable } from '@angular/core';
import { LoginService } from './login.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Subject, Subscription, BehaviorSubject,Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  multiSelectGroups: any[] = [];
  examsSettings =[]
  cardioExamsDefault =[
  'TTE Adults',
  'TTE Pediatric',
  'Stress-Echo',
  'Duplex Carotid',
  'Stress',
  'Holter ECG',
  'Consultation Letter']
  gastroExamsDefault = [
    'Colonoscopy',
    'Gastroscopy',
    'Gastro-Colonoscopy',
    'Sigmoidoscopy',
    'Abdomen US',
    'Clinics'
  ]
  eyesExamsDefault = [
    'FOV',
    'OCT',
    'FOV + OCT',
    'Pachymetry'
  ]
  obgynExamsDefault = [
    '1st',
    'NT',
    'Early Anatomy',
    '2nd/3rd Trimester',
    'Late Anatomy',
    'Specialized',
    'Fetal Echo',
    'Pediatric Echo',
    'Weight Assessment',
    'Tech Exam',
    'Gynecology',
    'Consultation Visit',
    'Third Scan'
  ]
  usgExamsDefault = [
    'Abdomen US',
    'MSK & Soft Tissues',
    'Ultrasound Scan Summary',
    'Endoscopy',
    'Consultation Letter',
    'consultation and follow up with media',
    'Clinics'
  ]
  categories={Pregnancy:['1st',
  'NT',
  'Early Anatomy',
  '2nd/3rd Trimester',
  'Late Anatomy',
  'Specialized',
  'Weight Assessment',
  'Tech Exam',
  'Consultation Visit',
  'Third Scan'],
  Gynecology:['Gynecology'],
  'Fetal Echo':['Fetal Echo'],
  'Pediatric Echo':['Pediatric Echo']
}
 insuranceMapping = {
  Platinum: 'פלטינום',
  Mushlam: 'מושלם',
  Sheli: 'שלי',
  Zahav: 'זהב',
  Kesef: 'כסף',
  Basis: 'בסיסי',
  Adif: 'עדיף',
  C: 'שיא'
};
hmoMapping={
  Macabi:'מכבי',
  Leumit:'לאומית',
  Meuhedet:'מאוחדת',
  Clalit:'כללית',
  Private:'פרטי',
  IDF:'צה"ל'
}
  public examsSettingsLoaded$: Subject<void> = new Subject<void>();
  constructor(public loginService: LoginService,private http:HttpClient) {
   
  }


  getDefault(){
    if (this.loginService.isCardio){
      return this.cardioExamsDefault
  }

  if(this.loginService.isEyes){
    return this.eyesExamsDefault
  }

  if(this.loginService.isGastro){
    return this.gastroExamsDefault
  }

  if(this.loginService.isUSG){
    return this.usgExamsDefault
  }
  return this.obgynExamsDefault
}

async getExams(){
  try {
    const data = await this.http.get('api/settings').toPromise();
    this.examsSettings=data['exams']
    this.examsSettingsLoaded$.next(data['exams']);
    return data['exams'];
  } catch (error) {
    console.error('Error fetching exams settings:', error);
    return []
  }
}


async getClinicTemplates(): Promise<any[]> {
  try {
    const data = await this.http.get('api/settings/clinic-templates').toPromise();
    return data['templates'] || [];
  } catch (error) {
    console.error('Error fetching clinic templates:', error);
    return [];
  }
}

async getExamsPrice(UID,type,insurance=null){
  try {
    const data = await this.http.get(`api/settings/prices/${UID}/${type}/${insurance}`).toPromise();
    return data['exams'];
  } catch (error) {
    console.error('Error fetching exams settings:', error);
    return []
  }
}


async updateExam(Exam): Promise<any>{
  if (Exam.AutoIndex == null) {
    throw new Error('AutoIndex is not set.');
  }

  try {
    return this.http.put(`/api/settings`,Exam).toPromise();
   
    
  } catch (error) {
    console.error('Error update exam:', error);
    throw error;
  }
}

async deleteExam(Exam): Promise<any>{
  if (Exam.AutoIndex == null) {
    throw new Error('AutoIndex is not set.');
  }

  try {
    return this.http.delete(`/api/settings`,{params:{examId:Exam.AutoIndex}}).toPromise();
   
    
  } catch (error) {
    console.error('Error delete exam:', error);
    throw error;
  }
}

async updateExamPrice(Exam): Promise<any>{
  if (Exam.AutoIndex == null) {
    throw new Error('AutoIndex is not set.');
  }

  try {
    return this.http.put(`/api/settings/prices`,Exam).toPromise();
   
    
  } catch (error) {
    console.error('Error update exam:', error);
    throw error;
  }
}

async deletePrice(price): Promise<any>{
  if (price.AutoIndex == null) {
    throw new Error('AutoIndex is not set.');
  }

  try {
    return this.http.delete(`/api/settings/prices`,{params:{AutoIndex:price.AutoIndex}}).toPromise();
   
    
  } catch (error) {
    console.error('Error delete price:', error);
    throw error;
  }
}
async saveNewExam(exam){
  return this.http.post('/api/settings',exam).toPromise()
}

async saveNewExamPrice(exam,type,insurance=null){
  const body={...exam,type}
  if(insurance){
    body['insurance']=insurance
  }
  return this.http.post('/api/settings/prices',body).toPromise()
}


getExam(AutoIndex){
  return this.examsSettings.find((exam)=>{exam.AutoIndex==AutoIndex})
}


getHolidays(year: number){
 return this.http.get<any[]>(`api/settings/holidays/${year}`)
}

getActivityHours(calendar = false, byRoom = false): Observable<any> {
  let url = '';

  if (byRoom) {
    url = `api/settings/activity-hours/${this.loginService.room}?byRoom=true`;
  } else if (this.loginService.doctor) {
    url = `api/settings/activity-hours/${this.loginService.doctor}`;
  } else {
    return;
  }

  if (calendar) {
    url += byRoom ? `&calendar=${calendar}` : `?calendar=${calendar}`;
  }

  return this.http.get(url);
}

updateRoomName(room){ 
  return this.http.put('api/rooms',room)
}

deleteRoom(roomId){
  return this.http.delete('/api/rooms/' + roomId)
}

getHMOQuota(HMO:string){
  const params = { UID:this.loginService.doctor, HMO };
  return this.http.get('/api/settings/HMOquota',{params}).toPromise()
}
getHMOQuotaByMonth(HMO:string,month=null,UID){
  const params = { UID, HMO };
  if (month) params['month']=month
  return this.http.get('/api/settings/HMOquotaByMonth',{params}).toPromise()
}

updateHMOQuota(payload: any) {
  payload['UID']=this.loginService.doctor
  return this.http.post('/api/settings/HMOquota', payload);
}


getAppointmentsCount(hmo: string, month: string): Observable<number> {
  return this.http.get<number>(`/api/appointment/countHMO?HMO=${hmo}&month=${month}&UID=${this.loginService.doctor}`);
}
getAppointmentsCountPromise(hmo: string, month: string,uid=this.loginService.doctor){
  return this.http.get<number>(`/api/appointment/countHMO?HMO=${hmo}&month=${month}&UID=${uid}`).toPromise();
}



saveActivityHours(data: any,byRoom=false): Observable<any> {
  let body: { UID?: any; RID?: any; days: any } = { days: data };

  if (byRoom) {
    body.RID = this.loginService.room;
  } else {
    body.UID = this.loginService.doctor;
  }
  return this.http.post(`api/settings/activity-hours`, body);
}

search(searchType,start,end,UID){
if (searchType=='deleted'){
  return this.http.get<any[]>(`api/appointment/deleted/`,{params:{start,end,UID}})
}
}


getSmsData(){
 return this.http.get<any>('api/settings/smsClinicData')
}

sendSmsData(smsObj){
return this.http.post('api/settings/smsCliniCData',smsObj)
}

updateExamOrder(exams){
  return this.http.post('api/settings/updateExamOrder',exams)
}

getMultiGroups(): Promise<any[]> {
  return this.http.get<any>(`/api/settings/groups`).toPromise().then(groups => {
    this.multiSelectGroups = groups;
    return groups;
  });
}

setDefaultMultiGroup(groupId: number): Promise<any> {
  return this.http.post("/api/settings/groups/default", { groupId }).toPromise();
}

updateMultiGroup(groupId: number, ids: number[], isByRooms: boolean): Promise<any> {
  return this.http
    .put(`/api/settings/groups/${groupId}`, {
      ids,
      isByRooms,
    })
    .toPromise();
}

deleteMultiGroup(groupId: number): Promise<any> {
  return this.http.delete(`/api/settings/groups/${groupId}`).toPromise();
}
createMultiGroup(isByRooms: boolean): Promise<any> {
  return this.http.post('/api/settings/groups', { isByRooms }).toPromise();
}


// ---- Pre-visit questionnaire templates -------------------------------------

async getQuestionnaires(): Promise<any[]> {
  try {
    const data = await this.http.get('/api/questionnaires').toPromise();
    return data['questionnaires'] || [];
  } catch (error) {
    console.error('Error fetching questionnaires:', error);
    return [];
  }
}

// Exam-type options for the editor's "Applies to Exam Types" picker: real
// examsSettings rows, or specialty defaults (AutoIndex null) when the clinic
// has no examsSettings — e.g. a questionnaire-only clinic (item 6).
async getQuestionnaireExamOptions(): Promise<any[]> {
  try {
    const data = await this.http.get('/api/questionnaires/exam-options').toPromise();
    return data['exams'] || [];
  } catch (error) {
    console.error('Error fetching questionnaire exam options:', error);
    return [];
  }
}

// Company-provided default templates, filtered server-side to the clinic's specialty.
async getQuestionnaireDefaults(): Promise<any[]> {
  try {
    const data = await this.http.get('/api/questionnaires/defaults').toPromise();
    return data['defaults'] || [];
  } catch (error) {
    console.error('Error fetching questionnaire defaults:', error);
    return [];
  }
}

saveQuestionnaire(questionnaire): Promise<any> {
  return this.http.post('/api/questionnaires', questionnaire).toPromise();
}

updateQuestionnaire(questionnaire): Promise<any> {
  if (questionnaire.AutoIndex == null) {
    throw new Error('AutoIndex is not set.');
  }
  return this.http.put('/api/questionnaires', questionnaire).toPromise();
}

deleteQuestionnaire(id: number): Promise<any> {
  return this.http.delete('/api/questionnaires', { params: { id } }).toPromise();
}


}